import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const AdminEventListSlice = createSlice({
  name: 'AdminEventList',
  initialState,
  reducers: {
    Admin_Event_List_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Admin_Event_List_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Admin_Event_List_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Admin_Event_List_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {Admin_Event_List_request, Admin_Event_List_success, Admin_Event_List_failure, Clear_Admin_Event_List_Check } = AdminEventListSlice.actions

export default AdminEventListSlice.reducer